export abstract class Mapper<E, M> {
  abstract fromMap(map: M): E;
}
